export default [{
    key: 'rzpAccountId',
    displayName: 'Rzp Account Id',
    value: ''
}, {
    key: 'gofRevenueShare',
    displayName: 'GoF Revenue Share',
    value: ''
}];
